import Container from "../../components/ui/Container.js"
import "./CrosswordView.scss"

import { useSteps } from "../../hooks/useSteps"
import { useMemo, useState } from "react"
import { ModalGanaste } from "../../components/games/ModalGanaste"
import { GoBackBtn } from "../../components/games/GoBackBtn"
import useFetch from "../../hooks/useFetch"

import { api } from "../../services/api/index"
import { useParams } from "react-router"
import { Grammar } from "../../components/games/grammar/Grammar"
import { ModalError } from "../../components/ui/modal/ModalError.js"
import { useTranslation } from "react-i18next"

const ElegirDificultad = ({ setDificultad }) => {
  let dificultades = ["easy", "hard"]

  const { t } = useTranslation()

  return (
    <>
      <div className="title">{t(`ui.games.headers.choose_a_difficulty`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex justify-content-center align-items-center flex-row">
          {dificultades.map((code) => (
            <div key={code} className="col-lg-4 col-6 py-1">
              <div className="box category" onClick={() => setDificultad(code)}>
                <span>
                  <b>{t(`ui.games.difficulties.${code}`)}</b>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

// const CrosswordsID = ({ id }) => {
//   const [ data, isPending, err ] = useFetch({
//     url: `${config.apiUrl}/games/${id}`
//   })

//   const showModalGanaste = useState(false)
//       , handleWin        = () => showModalGanaste[1](true)

//   if (isPending && !err)
//     return (
//       <div className="row my-5 py-5">
//         <center>
//           Cargando...
//         </center>
//       </div>
//     )

//   if (err)
//     return <NotFound />

//   return <>
//     <ModalGanaste show={showModalGanaste} />
//     {data && <CrosswordsGame
//                 data={data.entries}
//                 size={data.size}
//                 winCallback={handleWin}
//               />}
//     </>
// }

const GrammarLoader = ({ tag, difficulty, winCallback }) => {
  const { t } = useTranslation()
  const { url, opt } = useMemo(
    () =>
      api.games.Grammar.Generate({
        diff: difficulty,
        length: 5,
        types: "fill", // "*"
      }),
    [difficulty]
  )

  const [data, isPending, err] = useFetch({ url, opt })

  const showErr = useState(true)

  if (isPending && !err)
    return (
      <div className="row my-5 py-5">
        <center>{t("ui.btns.loading")}...</center>
      </div>
    )

  if (err) return <ModalError show={showErr} res={err} />

  return (
    <Grammar data={data} difficulty={difficulty} winCallback={winCallback} />
  )
}

const RandomLPracticePicker = () => {
  let [steps] = useSteps(["dificultad"]),
    setDificultad = steps.setter("dificultad")

  const showModalGanaste = useState(false),
    handleWin = () => {
      showModalGanaste[1](true)
    }

  return (
    <>
      <ModalGanaste show={showModalGanaste} steps={steps} />

      <GoBackBtn steps={steps} />

      {steps.at("dificultad") && (
        <ElegirDificultad setDificultad={setDificultad} />
      )}

      {steps.done && (
        <GrammarLoader
          tag={steps.data.tag}
          difficulty={steps.data.dificultad}
          winCallback={handleWin}
        />
      )}
    </>
  )
}

const LPracticeView = () => {
  const { id } = useParams()

  return (
    <Container>
      {id ? (
        // ? <CrosswordsID id={id} />
        <RandomLPracticePicker />
      ) : (
        <RandomLPracticePicker />
      )}
    </Container>
  )
}

export default LPracticeView
